var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#40ba8e;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#2e3e36;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_57",
    "data-name": "Rounded Rectangle 1 copy 57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,69.6a14.56,14.56,0,0,0-10.78,4.75L35.32,55a2.49,2.49,0,0,0-2.7,4.18L62.55,78.53A14.63,14.63,0,1,0,76,69.6Zm0,24.11a9.46,9.46,0,1,1,9.44-9.45A9.44,9.44,0,0,1,76,93.71Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_56",
    "data-name": "Rounded Rectangle 1 copy 56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76,1.09A14.66,14.66,0,0,0,62.51,21.37L34.4,39.53a14.59,14.59,0,1,0,2.83,4.06l27.93-18A14.64,14.64,0,1,0,76,1.09ZM24,59.26a9.46,9.46,0,1,1,9.44-9.45A9.45,9.45,0,0,1,24,59.26ZM76,25.2a9.46,9.46,0,1,1,9.44-9.46A9.44,9.44,0,0,1,76,25.2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cb6ecf8bc86054df349dca68c8ea4f92.svg";
export { ForwardRef as ReactComponent };